import {
  FormControl,
  FormLabel,
  Input,
  Textarea,
  FormErrorMessage,
  Button,
  Stack,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

const NameAndDescriptionForm = ({ widgetForm, onNext, onBack }) => {
  const {
    register,
    formState: { errors },
    trigger,
  } = useFormContext();

  const handleNext = async () => {
    const valid = await trigger(["widget_name", "widget_description"]);
    if (valid) {
      onNext();
    }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); handleNext(); }}>
      <Stack spacing={4}>
        <FormControl isInvalid={!!errors?.widget_name}>
          <FormLabel>Name</FormLabel>
          <Input
            placeholder="Enter widget name"
            {...register("widget_name", {
              required: "Widget name is required",
            })}
          />
          <FormErrorMessage>{errors?.widget_name?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors?.widget_description}>
          <FormLabel>Description</FormLabel>
          <Textarea
            placeholder="Only for your reference, not used as part of the prompt"
            {...register("widget_description", {
              required: "Widget description is required",
            })}
          />
          <FormErrorMessage>
            {errors?.widget_description?.message}
          </FormErrorMessage>
        </FormControl>

        <Stack direction="row" justify="flex-end" spacing={3} pt={4}>
          <Button onClick={onBack}>Back</Button>
          <Button colorScheme="blue" type="button" onClick={handleNext}>
            Next
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};

export default NameAndDescriptionForm;
